import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { HEDGE_SECTION_KEY } from "../hedge.constants";

import { rows } from "./section-hedge-financials-rows";

export class HedgeFinancials extends Component {
  render() {
    const { data, history, hedgeId, enableEditButton, ...other } = this.props;
    if (!data) {
      return null;
    }

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Financials",
            key: HEDGE_SECTION_KEY.FINANCIALS,
            isExpandable: true,
            isTitleGroup: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/hedges/${hedgeId}/edit/${HEDGE_SECTION_KEY.FINANCIALS}`),
            sections: [
              <AccordionSection eventHandlers={this.props.eventHandlers} rows={rows} data={data} />
            ]
          }
        ]}
      />
    );
  }
}
